import appStrings from '@/assets/constants/appStrings-no.ts';
import { Testimonials } from '@/components/testimonials/index.ts';
import { testimonialsQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import ActionButton from '../../components/ActionButton/index.ts';
import Circle from '../../components/Circle/index.ts';
import FaqList from '../../components/FaqList/index.ts';
import Page from '../../components/Page/index.ts';
import PartnerBanks from '../../components/PartnerBanks/index.ts';
import Section from '../../components/Section/index.ts';
import SectionTitle from '../../components/SectionTitle/index.ts';

import type { Route } from './+types/savings-potential.ts';
import SimplifiedBobDoodle from './_components/HeaderSection/_components/SimplifiedBobDoodle/index.ts';
import RefinancingArticle from './_components/RefinancingArticle/RefinancingArticle.tsx';

const partnerBanks = [
  { name: 'avida', linkEnabled: true },
  { name: 'brabank', linkEnabled: false },
  { name: 'expressbank', linkEnabled: true },
  { name: 'ikanobank', linkEnabled: true },
  { name: 'instabank', linkEnabled: false },
  { name: 'morrowbank', linkEnabled: true },
  { name: 'remember', linkEnabled: false },
  { name: 'resursbank', linkEnabled: true },
  { name: 'nordax', linkEnabled: true },
  { name: 'santander', linkEnabled: false },
  { name: 'svea', linkEnabled: true },
  { name: 'tfbank', linkEnabled: true },
  { name: 'ya', linkEnabled: true },
];

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const testimonials = await queryClient.query(testimonialsQuery());
  return { testimonials };
}

export default function SavingsPotential({ loaderData }: Route.ComponentProps) {
  return (
    <Page title={appStrings.PAGES.REFINANCING}>
      <SimplifiedBobDoodle />
      {/*{showChatContainer ? null : <PageHeaderVariants />}*/}
      <Section background="paper">
        <Testimonials data={loaderData.testimonials} />
      </Section>
      <Section background="paper">
        <SectionTitle title="Våre partnerbanker" />
        <PartnerBanks variant="unicolored" data={partnerBanks} isRefin />
      </Section>
      <RefinancingArticle />
      <Section>
        <FaqList category="Refinansiering" />
      </Section>
      <Section extraPadding background="paper">
        <Circle position="topLeft" color="default" />
        <Circle position="bottomRight" color="default" />
        <SectionTitle
          title="Når kan du bli gjeldfri?"
          subtitle="Se om du kan bli raskere gjeldfri ved å refinansiere"
        />

        <ActionButton
          label="Sjekk nå"
          flow="debt_check"
          step="skip_start_set_savings_potential_mode"
          color="secondary"
        />
      </Section>
    </Page>
  );
}
